<script setup>
import moment from "moment";

const props = defineProps({
  id: Number,
  title: String,
  publishedAt: [String, Date],
  xCategoryLinks: Array,
});

const tag = computed(() => {
  return props.xCategoryLinks[0].xCategory.title;
});

const isFuture = computed(() => {
  if (!props.publishedAt) return false;
  return moment(props.publishedAt).isAfter(moment());
});
</script>

<template lang="pug">
nuxt-link.block.my-4(v-if="id", :to="`/articles/${id}`")
  a-card
    .flex.flex-row.justify-between.items-center
      .text-xl
        a-tag.mr-4(v-if="tag", color="arcoblue") {{ tag }}
        span {{ title }}
      .text-hint-400(v-if="!isFuture") {{ formatDateTime(publishedAt) }}
</template>
